import { render, staticRenderFns } from "./MovementAdjustmentsHome.vue?vue&type=template&id=2f70ccfb"
import script from "./MovementAdjustmentsHome.vue?vue&type=script&lang=js"
export * from "./MovementAdjustmentsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports